function runPo2go(){
  var store_config = {
    "punchout_only":0,
    "transfer_label":"Transfer Cart",
    "custom_style":"",
    "checkout_selector":"button[name=\"checkout\"]",
    "transfer_selector":"button[name=\"transfer_items\"]",
    "transfer_btn_html":"<button type=\"submit\" name=\"transfer_items\" class=\"button-primary mdc-ripple-surface mdc-ripple-upgraded\" onClick=\"POSession.extension.transferCart(); return false;\" >Transfer Cart</button>",
    "return_selector": "body.punchout header.site-header",
    "return_btn_html": "<button type=\"submit\" name=\"close_punchout\" class=\"button-primary mdc-ripple-surface mdc-ripple-upgraded\" onClick=\"POSession.cancel();\" >Close Ariba Session<\/button>"
  };
   
    POExt = new Po2go_Shopify(store_config);     
    POSession = new Po2go({
        'account':'',
        'punchout_only' : store_config.punchout_only,
        'extension' : POExt
    });
    POSession.init();
    POSession.extension.setupPage();
    if (POSession.session_id !== '') {
      // Hide account actions in header when Punchout is active
      $('.site-header-actions__account-link').hide();
      POSession.extension.returnToProcButton(); // Add this if you need to add a Close PunchOut button; don't forget to add your return_selector and return_btn_html to the store_config
    }
}